module.exports = __webpack_public_path__ + "static/media/checkbox.dd6a0aae.svg";